import TextInput from '@/components/form/text-input';
import { FC } from 'react';

interface Props {
  phrase: string;
}

const PhraseButton: FC<Props> = ({ phrase }) => {
  return <TextInput size="small" value={phrase} readonly name="phrase" />;
};

export default PhraseButton;
